function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Single source of truth for every string the feedback widget renders. Copy changes belong here
 * rather than in the components.
 */
import { GENERAL_CATEGORY_ID, IDEA_CATEGORY_ID, PROBLEM_CATEGORY_ID, PRODUCT_CATEGORY_ID } from './feedbackConstants';
export const FEEDBACK_TAB_LABEL = 'FEEDBACK';
export const FEEDBACK_TAB_ARIA_LABEL = 'Send feedback';
export const FEEDBACK_CLOSE_LABEL = 'Close feedback';
export const FEEDBACK_OVERLAY_LABEL = 'Close feedback';

// Rendered as an angle-left icon followed by "Back". The accessible name is more specific so it
// never collides with the footer Back button that sits on the same screen.
export const BACK_LINK_TEXT = 'Back';
export const BACK_LINK_ARIA_LABEL = 'Back to feedback options';
export const BACK_BUTTON_LABEL = 'Back';
export const DONE_BUTTON_LABEL = 'Done';
export const SUBMITTING_LABEL = 'Sending...';
export const SUBMIT_ERROR_MESSAGE = 'We could not send your feedback. Please check your ' + 'connection and try again.';
export const PICKER_TITLE = "What's on your mind?";
export const PICKER_SUBTITLE = 'Pick one, then tell us more.';
// Shown when no feedback form type reached this account, so there is nothing to pick.
export const PICKER_EMPTY_MESSAGE = 'Feedback is not available right now.';
export const CONTEXT_STRIP_LABELS = {
  page: 'Page',
  browser: 'Browser',
  timestamp: 'Time'
};
export const SCREENSHOT_ATTACHED_LABEL = 'Screenshot of current screen attached';
export const SCREENSHOT_CAPTURING_LABEL = 'Capturing screenshot…';
export const SCREENSHOT_MISSING_LABEL = 'No screenshot attached';
export const SCREENSHOT_ERROR_LABEL = 'We could not capture this screen. ' + 'You can retry or send the report without a screenshot.';
export const SCREENSHOT_RETAKE_LABEL = 'Retake';
export const SCREENSHOT_REMOVE_LABEL = 'Remove';

// Every form that fills the single Feedback slot - the shared `feedbackGeneral` and any
// customer-specific replacement such as `feedbackTrc` - shows the same icon, label and copy, so
// users only ever see one Feedback option. Only the fields differ, and those come from the
// FormType `formatInput`.
const FEEDBACK_SLOT_COPY = {
  glyph: 'comments',
  optionTitle: 'Feedback',
  optionDescription: 'Anything else you want to tell us',
  badgeGlyph: 'comments',
  title: 'Feedback',
  subtitle: "How's it going so far?",
  submitLabel: 'Send feedback',
  submitColor: 'primary',
  confirmationTitle: 'Thanks — got it.',
  // Intentionally empty: the confirmation screen renders the note only when there is one.
  confirmationNote: ''
};

// `glyph` is the category icon in the picker; `badgeGlyph` is the icon in the screen header badge.
// Both are Font Awesome names rendered through the shared Icon component. Field labels and
// placeholders are not here - they come from the FormType `formatInput` of each category.
export const FEEDBACK_CATEGORIES = [{
  id: PROBLEM_CATEGORY_ID,
  glyph: 'bug',
  optionTitle: 'Problem',
  optionDescription: "Something's broken or not working right",
  badgeGlyph: 'circle-exclamation',
  title: 'Problem',
  subtitle: "We'll attach the technical details automatically — just tell us what happened.",
  submitLabel: 'Send report',
  submitColor: 'danger',
  confirmationTitle: 'Report sent.',
  // Problem note is chosen at submit time via getFeedbackConfirmationNote.
  confirmationNote: ''
}, {
  id: IDEA_CATEGORY_ID,
  glyph: 'lightbulb',
  optionTitle: 'Idea',
  optionDescription: "A feature or improvement you'd like to see",
  badgeGlyph: 'lightbulb',
  title: 'Idea',
  subtitle: "Describe what you'd like to see — as much detail as you want.",
  submitLabel: 'Submit idea',
  submitColor: 'primary',
  confirmationTitle: 'Idea submitted.',
  confirmationNote: "We'll review it with the team."
}, _objectSpread({
  id: GENERAL_CATEGORY_ID
}, FEEDBACK_SLOT_COPY), _objectSpread({
  id: PRODUCT_CATEGORY_ID
}, FEEDBACK_SLOT_COPY)];
export const getFeedbackCategory = categoryId => FEEDBACK_CATEGORIES.find(({
  id
}) => id === categoryId) || null;
export const PROBLEM_CONFIRMATION_NOTE_WITH_SCREENSHOT = 'The screenshot and technical details ' + 'were attached.';
export const PROBLEM_CONFIRMATION_NOTE_DIAGNOSTICS_ONLY = 'The technical details were attached.';

/**
 * Confirmation body copy. Problem notes depend on whether a screenshot was actually uploaded.
 */
export const getFeedbackConfirmationNote = (categoryId, {
  screenshotAttached: _screenshotAttached = false
} = {}) => {
  var _getFeedbackCategory;
  if (categoryId === PROBLEM_CATEGORY_ID) {
    return _screenshotAttached ? PROBLEM_CONFIRMATION_NOTE_WITH_SCREENSHOT : PROBLEM_CONFIRMATION_NOTE_DIAGNOSTICS_ONLY;
  }
  return ((_getFeedbackCategory = getFeedbackCategory(categoryId)) === null || _getFeedbackCategory === void 0 ? void 0 : _getFeedbackCategory.confirmationNote) || '';
};